import { staticText } from '../../utils/translations/staticText';

export const TRANSLATIONS = staticText({
  aio_module_view_details: {
    _: 'View Details',
    zh: '查看詳情',
  },
  aio_module_related_reading: {
    _: 'Related Reading:',
    zh: '延伸閱讀：',
  },
  aio_module_apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
});

export type AioModuleTranslations = typeof TRANSLATIONS;
